export enum ScheduleFrequency {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
  Years = 'Years',
}

export enum ScheduleDayOfWeek {
  Mon = 1,
  Tue = 2,
  Wed = 3,
  Thu = 4,
  Fri = 5,
  Sat = 6,
  Sun = 7,
}

export enum ScheduleDayOfMonth {
  '1stMon' = 101,
  '1stTue' = 102,
  '1stWed' = 103,
  '1stThu' = 104,
  '1stFri' = 105,
  '1stSat' = 106,
  '1stSun' = 107,
  '2ndMon' = 108,
  '2ndTue' = 109,
  '2ndWed' = 110,
  '2ndThu' = 111,
  '2ndFri' = 112,
  '2ndSat' = 113,
  '2ndSun' = 114,
  '3rdMon' = 115,
  '3rdTue' = 116,
  '3rdWed' = 117,
  '3rdThu' = 118,
  '3rdFri' = 119,
  '3rdSat' = 120,
  '3rdSun' = 121,
  '4thMon' = 122,
  '4thTue' = 123,
  '4thWed' = 124,
  '4thThu' = 125,
  '4thFri' = 126,
  '4thSat' = 127,
  '4thSun' = 128,
  '1st' = 201,
  '2nd' = 202,
  '3rd' = 203,
  '4th' = 204,
  '5th' = 205,
  '6th' = 206,
  '7th' = 207,
  '8th' = 208,
  '9th' = 209,
  '10th' = 210,
  '11th' = 211,
  '12th' = 212,
  '13th' = 213,
  '14th' = 214,
  '15th' = 215,
  '16th' = 216,
  '17th' = 217,
  '18th' = 218,
  '19th' = 219,
  '20th' = 220,
  '21st' = 221,
  '22nd' = 222,
  '23rd' = 223,
  '24th' = 224,
  '25th' = 225,
  '26th' = 226,
  '27th' = 227,
  '28th' = 228,
  '29th' = 229,
  '30th' = 230,
  '31st' = 231,
  'LastDay' = -1,
}

export const ScheduleDay = {
  ...ScheduleDayOfWeek,
  ...ScheduleDayOfMonth,
};

export enum ScheduleOffsetType {
  Days = 'd',
  BusinessDays = 'b',
  Weeks = 'w',
  Months = 'm',
  Years = 'y',
  StartsOfWeek = 's',
  StartsOfMonth = 't',
  StartsOfYear = 'u',
  EndsOfWeek = 'n',
  EndsOfMonth = 'e',
  EndsOfYear = 'z',
}

export enum ScheduleOffsetDirection {
  Before = '-',
  After = '+',
}

export type ScheduleOffset = {
  interval: number;
  type: ScheduleOffsetType;
  direction: ScheduleOffsetDirection;
};

export type IceCubeSchedulRuleType =
  | 'IceCube::DailyRule'
  | 'IceCube::WeeklyRule'
  | 'IceCube::MonthlyRule'
  | 'IceCube::YearlyRule';

export type IceCubeSchedule = {
  ':rrules': {
    ':rule_type': IceCubeSchedulRuleType;
    ':validations'?: {
      ':day'?: number[]; // Weekly: 0-6 (Sun-Sat)
      ':day_of_week'?: Record<string, number[]>; // Monthly: Day 0-6 (Sun-Sat), Week 1-4 or -1 for last day
      ':day_of_month'?: number[]; // Monthly: 1-31 or -1 for last day
    };
    ':interval': number;
  }[];
};

export type LegacySchedule = {
  frequency: ScheduleFrequency;
  interval: number;
  day?: number[]; // Weekly 0-6 (Mon-Sun)
  dayOfWeek?: Record<number, number[]>; // Monthly: Day 0-6 (Mon-Sun), Week 1-4 or -1 for last day
  dayOfMonth?: number[]; // Monthly: 1-31 or -1 for last day
};
